(function(){'use strict';

/* HELPERS */
function $(s,p){return (p||document).querySelector(s)}
function $$(s,p){return Array.prototype.slice.call((p||document).querySelectorAll(s))}
/* v15 fix: alleen touch/scroll/wheel zijn passive. Submit/click moeten preventDefault kunnen doen
   (anders werd een product via de knop én via de normale form-post dubbel toegevoegd). */
var PASSIVE={touchstart:1,touchmove:1,touchend:1,wheel:1,scroll:1,mousemove:1};
function on(el,e,fn){if(el)el.addEventListener(e,fn,PASSIVE[e]?{passive:true}:false)}

/* GLOBAL EVENT DELEGATION */
document.addEventListener('click', function(e){
  if(e.target.closest('[data-cart-close]')){e.preventDefault();closeCart();return}
  if(e.target.closest('[data-cart-toggle]')){e.preventDefault();openCart();return}
  var qtyBtn=e.target.closest('[data-cart-qty]');
  if(qtyBtn){
    e.preventDefault();
    var line=parseInt(qtyBtn.dataset.line,10);
    var direction=qtyBtn.dataset.cartQty;
    var item=qtyBtn.closest('.cart-item,.cart-page-item');
    var valEl=item&&(item.querySelector('.cart-qty__val')||item.querySelector('.quantity-selector__input'));
    var current=valEl?parseInt((valEl.value||valEl.textContent).toString().trim(),10)||1:1;
    var next=direction==='plus'?current+1:Math.max(0,current-1);
    cartChangeLine(line,next);
    return;
  }
  var rmBtn=e.target.closest('[data-cart-remove]');
  if(rmBtn){e.preventDefault();cartChangeLine(parseInt(rmBtn.dataset.line,10),0);return}
  if(e.target.closest('[data-mobile-menu-toggle]')){
    e.preventDefault();
    var mn=$('#mobile-nav');if(!mn)return;
    var isOpen=mn.classList.toggle('active');
    document.body.style.overflow=isOpen?'hidden':'';
    return;
  }
  if(e.target.closest('[data-search-toggle]')){
    e.preventDefault();
    var sm=$('#search-modal');if(!sm)return;
    sm.classList.toggle('active');
    if(sm.classList.contains('active')){var i=sm.querySelector('input');if(i)i.focus();document.body.style.overflow='hidden'}
    else{document.body.style.overflow=''}
    return;
  }
  var faqBtn=e.target.closest('[data-faq-toggle]');
  if(faqBtn){
    e.preventDefault();
    var fitem=faqBtn.closest('.faq-item');if(!fitem)return;
    var wasActive=fitem.classList.contains('active');
    $$('.faq-item.active').forEach(function(el){el.classList.remove('active')});
    if(!wasActive)fitem.classList.add('active');
    return;
  }
  var tabBtn=e.target.closest('[data-tab]');
  if(tabBtn){
    e.preventDefault();
    var target=tabBtn.getAttribute('data-tab');
    $$('[data-tab]').forEach(function(t){t.classList.remove('active')});
    $$('[data-panel]').forEach(function(p){p.classList.remove('active')});
    tabBtn.classList.add('active');
    var panel=$('[data-panel="'+target+'"]');if(panel)panel.classList.add('active');
    return;
  }
  var wbtn=e.target.closest('[data-wishlist]');
  if(wbtn){
    e.preventDefault();e.stopPropagation();
    var id=wbtn.dataset.wishlist;
    try{
      var l=JSON.parse(localStorage.getItem('wishlist')||'[]');
      var wi=l.indexOf(id);
      if(wi>-1){l.splice(wi,1);wbtn.classList.remove('active')}
      else{l.push(id);wbtn.classList.add('active')}
      localStorage.setItem('wishlist',JSON.stringify(l));
    }catch(err){}
    return;
  }
  var qm=e.target.closest('[data-qty-minus]');
  if(qm){e.preventDefault();var i1=qm.parentElement.querySelector('input');if(i1&&parseInt(i1.value,10)>1)i1.value=parseInt(i1.value,10)-1;return}
  var qp=e.target.closest('[data-qty-plus]');
  if(qp){e.preventDefault();var i2=qp.parentElement.querySelector('input');if(i2)i2.value=parseInt(i2.value,10)+1;return}
  if(e.target.closest('[data-filter-toggle]')){var fs2=$('#filter-sidebar');if(fs2)fs2.classList.toggle('active');return}
  if(e.target.id==='cart-overlay'){closeCart();return}
  if(e.target.id==='search-modal'){var sm2=$('#search-modal');if(sm2){sm2.classList.remove('active');document.body.style.overflow=''}return}
  if(e.target.closest('#cart-toast')){var ct=$('#cart-toast');if(ct){ct.classList.add('hiding');setTimeout(function(){ct.hidden=true},300)}return}
  if(e.target.closest('#back-to-top')){window.scrollTo({top:0,behavior:'smooth'});return}
}, false);

/* ESCAPE sluit drawer / zoeken / menu */
document.addEventListener('keydown', function(e){
  if(e.key!=='Escape')return;
  var cd=$('#cart-drawer');if(cd&&cd.classList.contains('active')){closeCart();return}
  var sm=$('#search-modal');if(sm&&sm.classList.contains('active')){sm.classList.remove('active');document.body.style.overflow='';return}
  var mn=$('#mobile-nav');if(mn&&mn.classList.contains('active')){mn.classList.remove('active');document.body.style.overflow='';return}
});

/* PARTICLES (subtiele achtergrond) */
function initParticles(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var c=document.createElement('canvas');c.id='particles-canvas';document.body.appendChild(c);
  var ctx=c.getContext('2d');var particles=[];var w,h;
  function resize(){w=c.width=window.innerWidth;h=c.height=window.innerHeight}
  resize();window.addEventListener('resize',resize);
  for(var i=0;i<20;i++)particles.push({x:Math.random()*w,y:Math.random()*h,vx:(Math.random()-.5)*.25,vy:(Math.random()-.5)*.25,r:Math.random()*1.2+.5,a:Math.random()*.25+.1});
  function draw(){
    ctx.clearRect(0,0,w,h);
    particles.forEach(function(p){p.x+=p.vx;p.y+=p.vy;if(p.x<0)p.x=w;if(p.x>w)p.x=0;if(p.y<0)p.y=h;if(p.y>h)p.y=0;ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,Math.PI*2);ctx.fillStyle='rgba(168,184,208,'+p.a+')';ctx.fill()});
    for(var i=0;i<particles.length;i++)for(var j=i+1;j<particles.length;j++){var dx=particles[i].x-particles[j].x;var dy=particles[i].y-particles[j].y;var d=Math.sqrt(dx*dx+dy*dy);if(d<90){ctx.beginPath();ctx.moveTo(particles[i].x,particles[i].y);ctx.lineTo(particles[j].x,particles[j].y);ctx.strokeStyle='rgba(168,184,208,'+(0.035*(1-d/90))+')';ctx.lineWidth=.5;ctx.stroke()}}
    requestAnimationFrame(draw);
  }
  draw();
}

/* MOUSE GLOW (desktop) — cursor zelf is een echte muispijl, zie snippets/custom-cursor.liquid */
if(window.matchMedia('(hover:hover) and (pointer:fine)').matches){
  var glow=document.createElement('div');glow.className='mouse-glow';document.body.appendChild(glow);
  var gx=-500,gy=-500,gtx=-500,gty=-500;
  document.addEventListener('mousemove',function(e){gtx=e.clientX;gty=e.clientY},{passive:true});
  (function animGlow(){gx+=(gtx-gx)*.08;gy+=(gty-gy)*.08;glow.style.left=gx+'px';glow.style.top=gy+'px';requestAnimationFrame(animGlow)})();
}

/* SCROLL REVEAL */
function initReveal(){
  var sels=['.section__hd','.section__header','.product-card','.collection-tile','.blog-card','.faq-item','.usp-bar__item','.review-card','.hero__content','.hero__stats','.featured-collection__header','.newsletter__content','.product-page__gallery','.product-page__info','.contact-info__item','.about-stat','.trust-badge-item','.compare-table','.quiz','.insta-feed','.trust-counter'];
  sels.forEach(function(s){$$(s).forEach(function(el,i){if(!el.hasAttribute('data-reveal')){el.setAttribute('data-reveal','');el.style.transitionDelay=(i%4)*.07+'s'}})});
  if(!('IntersectionObserver' in window)){$$('[data-reveal]').forEach(function(el){el.classList.add('revealed')});return}
  var obs=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('revealed');obs.unobserve(e.target)}})},{threshold:.1,rootMargin:'0px 0px -40px 0px'});
  $$('[data-reveal]').forEach(function(el){obs.observe(el)});
}

/* PARALLAX HERO */
function initParallax(){
  var bg=$('.hero__bg img,.hero__bg video');var content=$('.hero__content');
  window.addEventListener('scroll',function(){var s=window.pageYOffset;var h=window.innerHeight;if(s<h*1.2){if(bg)bg.style.transform='scale(1.05) translateY('+s*.15+'px)';if(content){content.style.opacity=Math.max(0,1-s/(h*.6));content.style.transform='translateY('+s*.2+'px)'}}},{passive:true});
}

/* TILT 3D */
function initTilt(){
  if(!window.matchMedia('(hover:hover) and (pointer:fine)').matches)return;
  $$('.product-card,.collection-tile,.blog-card').forEach(function(c){
    on(c,'mousemove',function(e){var r=c.getBoundingClientRect();var x=e.clientX-r.left;var y=e.clientY-r.top;var rx=((y-r.height/2)/(r.height/2))*-2.5;var ry=((x-r.width/2)/(r.width/2))*2.5;c.style.transform='perspective(800px) rotateX('+rx+'deg) rotateY('+ry+'deg) translateY(-4px)'});
    on(c,'mouseleave',function(){c.style.transform=''});
  });
}

/* COUNTER ANIMATION */
function initCounters(){
  if(!('IntersectionObserver' in window))return;
  $$('.hero__stat-value,.about-stat__value,.trust-counter__value').forEach(function(s){
    var t=s.textContent;var m=t.match(/(\d+)/);if(!m)return;var target=parseInt(m[0],10);var suffix=t.replace(m[0],'');
    var done=false;
    var o=new IntersectionObserver(function(es){if(es[0].isIntersecting&&!done){done=true;var cur=0;var step=Math.max(1,Math.ceil(target/40));var iv=setInterval(function(){cur+=step;if(cur>=target){cur=target;clearInterval(iv)}s.textContent=cur+suffix},25)}},{threshold:.5});
    o.observe(s);
  });
}

/* MAGNETIC BUTTONS (desktop) */
function initMagnetic(){
  if(!window.matchMedia('(hover:hover) and (pointer:fine)').matches)return;
  $$('.btn--primary,.btn--cart').forEach(function(b){
    on(b,'mousemove',function(e){var r=b.getBoundingClientRect();b.style.transform='translate('+(e.clientX-r.left-r.width/2)*.1+'px,'+(e.clientY-r.top-r.height/2)*.1+'px)'});
    on(b,'mouseleave',function(){b.style.transform=''});
  });
}

/* SCROLL PROGRESS */
function initProgress(){
  var bar=document.createElement('div');bar.style.cssText='position:fixed;top:0;left:0;height:2px;background:linear-gradient(90deg,#00f0ff,#7b2fff,#ff2d6b);z-index:10001;width:0;transition:width .1s linear';document.body.appendChild(bar);
  window.addEventListener('scroll',function(){var max=document.documentElement.scrollHeight-window.innerHeight;bar.style.width=(max>0?window.pageYOffset/max*100:0)+'%'},{passive:true});
}

/* STICKY HEADER */
var header=$('#site-header');if(header)window.addEventListener('scroll',function(){header.classList.toggle('scrolled',window.pageYOffset>50)},{passive:true});

/* CART DRAWER */
function openCart(){var cd=$('#cart-drawer');var co=$('#cart-overlay');if(cd)cd.classList.add('active');if(co)co.classList.add('active');document.body.style.overflow='hidden'}
function closeCart(){var cd=$('#cart-drawer');var co=$('#cart-overlay');if(cd)cd.classList.remove('active');if(co)co.classList.remove('active');document.body.style.overflow=''}
window.mpOpenCart=openCart;

/* Vervangt drawer + tellers met verse HTML van de header-sectie */
function refreshHeader(keepOpen){
  return fetch('/?sections=header').then(function(r){return r.json()}).then(function(data){
    if(!data||!data.header)return;
    var tmp=document.createElement('div');tmp.innerHTML=data.header;
    var newDrawer=tmp.querySelector('#cart-drawer');var oldDrawer=$('#cart-drawer');
    if(newDrawer&&oldDrawer){var wasActive=oldDrawer.classList.contains('active');oldDrawer.outerHTML=newDrawer.outerHTML;if(wasActive||keepOpen){var fresh=$('#cart-drawer');if(fresh)fresh.classList.add('active')}}
    var newCount=tmp.querySelector('.header__cart-count');var oldCount=$('.header__cart-count');var btn=$('.header__actions [data-cart-toggle]');
    if(oldCount&&newCount){oldCount.textContent=newCount.textContent}else if(newCount&&btn){btn.appendChild(newCount.cloneNode(true))}else if(oldCount&&!newCount){oldCount.remove()}
    var cnt=newCount?newCount.textContent:'';var oldMb=$('.mb-cart-badge');
    if(oldMb&&cnt){oldMb.textContent=cnt}else if(!oldMb&&cnt){var mbBtn=$('.mobile-bottom-nav [data-cart-toggle]');if(mbBtn){var s=document.createElement('span');s.className='mb-cart-badge';s.textContent=cnt;mbBtn.appendChild(s)}}else if(oldMb&&!cnt){oldMb.remove()}
  });
}

function cartChangeLine(line, qty){
  var drawer=$('#cart-drawer');
  if(drawer)drawer.classList.add('cart-drawer--loading');
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
  .then(function(r){return r.json()})
  .then(function(){
    if(window.location.pathname.indexOf('/cart')===0){window.location.reload();return}
    return refreshHeader(false);
  })
  .catch(function(err){console.warn('Cart update failed',err)})
  .finally(function(){var d=$('#cart-drawer');if(d)d.classList.remove('cart-drawer--loading')});
}

/* SORT */
var ss=$('[data-sort-select]');if(ss)on(ss,'change',function(){var u=new URL(window.location.href);u.searchParams.set('sort_by',ss.value);window.location.href=u.toString()});

/* BACK TO TOP */
function initBackToTop(){
  var btn=$('#back-to-top');if(!btn)return;
  window.addEventListener('scroll',function(){if(window.pageYOffset>500){btn.hidden=false;btn.classList.add('visible')}else{btn.classList.remove('visible')}},{passive:true});
}

/* WISHLIST (status bij laden) */
function initWishlist(){
  try{var list=JSON.parse(localStorage.getItem('wishlist')||'[]');$$('[data-wishlist]').forEach(function(btn){if(list.indexOf(btn.dataset.wishlist)>-1)btn.classList.add('active')})}catch(e){}
}

/* RECENTLY VIEWED */
function initRecentlyViewed(){
  if(document.body.className.indexOf('template-product')>-1){
    var p=$('[data-product-id]');if(p){
      var id=p.dataset.productId;
      try{var l=JSON.parse(localStorage.getItem('recent')||'[]');var i=l.indexOf(id);if(i>-1)l.splice(i,1);l.unshift(id);if(l.length>6)l=l.slice(0,6);localStorage.setItem('recent',JSON.stringify(l))}catch(e){}
    }
  }
}

/* ADD TO CART — AJAX, daarna drawer openen (met upsells + bundelvoordeel) */
$$('form[action*="/cart/add"]').forEach(function(f){
  on(f,'submit',function(e){
    if(window.location.pathname.indexOf('/cart')===0)return;
    e.preventDefault();
    if(f.dataset.busy==='1')return;
    f.dataset.busy='1';
    var btn=f.querySelector('button[type="submit"]');
    var originalText='';
    if(btn){originalText=btn.innerHTML;btn.disabled=true;btn.classList.add('btn--loading');btn.innerHTML='<span class="btn-spinner"></span> Toevoegen...'}
    fetch('/cart/add.js',{method:'POST',body:new FormData(f),headers:{'Accept':'application/json'}})
      .then(function(r){if(!r.ok)throw new Error('Add failed');return r.json()})
      .then(function(){return refreshHeader(true)})
      .then(function(){
        openCart();
        if(btn){btn.disabled=false;btn.classList.remove('btn--loading');btn.innerHTML='<span class="btn-checkmark">✓</span> Toegevoegd';setTimeout(function(){btn.innerHTML=originalText},1800)}
      })
      .catch(function(){
        if(btn){btn.disabled=false;btn.classList.remove('btn--loading');btn.innerHTML=originalText}
        alert('Toevoegen lukte niet. Probeer het opnieuw of ververs de pagina.');
      })
      .finally(function(){f.dataset.busy='0'});
  });
});

/* INIT */
document.addEventListener('DOMContentLoaded',function(){
  initReveal();
  initBackToTop();
  initWishlist();
  initRecentlyViewed();
  initProgress();
});
function deferToIdle(fn){if('requestIdleCallback' in window){requestIdleCallback(fn,{timeout:2000})}else{setTimeout(fn,200)}}
window.addEventListener('load',function(){
  deferToIdle(initParticles);
  deferToIdle(initParallax);
  deferToIdle(initTilt);
  deferToIdle(initCounters);
  deferToIdle(initMagnetic);
  $$('[data-reveal]').forEach(function(el){if(el.getBoundingClientRect().top<window.innerHeight)el.classList.add('revealed')});
});

})();

/* REVIEWS CAROUSEL */
(function(){
  var track=document.getElementById('reviews-track');
  if(!track)return;
  var prev=document.getElementById('reviews-prev');
  var next=document.getElementById('reviews-next');
  function scroll(dir){var card=track.querySelector('.reviews-carousel__card');if(!card)return;track.scrollBy({left:dir*(card.offsetWidth+16),behavior:'smooth'})}
  if(prev)prev.addEventListener('click',function(){scroll(-1)});
  if(next)next.addEventListener('click',function(){scroll(1)});
})();

/* Trust badges auto-scroll op mobiel */
(function(){
  if(window.innerWidth > 768) return;
  var badges = document.querySelectorAll('.trust-badge-item');
  if(badges.length < 2) return;
  var container = badges[0].parentElement;
  if(!container) return;
  var idx = 0;
  setInterval(function(){
    if(!document.body.contains(container)) return;
    idx = (idx + 1) % badges.length;
    var target = badges[idx];
    container.scrollTo({left: target.offsetLeft - container.offsetLeft - 20, behavior: 'smooth'});
  }, 4000);
})();
